import { render, staticRenderFns } from "./WfUserDevCollectionModal.vue?vue&type=template&id=71853b74&"
import script from "./WfUserDevCollectionModal.vue?vue&type=script&lang=js&"
export * from "./WfUserDevCollectionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports